import axios from 'axios'

const TransferService = {
  async get (params = {}) {
    return axios.get('wo/inter-warehouse-transfer/requests', { params })
  },

  async histories (params = {}) {
    return axios.get('wo/reports/inter-warehouse-transfer/request-histories', { params })
  },

  async show (id) {
    return axios.get(`wo/inter-warehouse-transfer/requests/${id}`)
  },

  async post (params = {}) {
    return axios.post('wo/inter-warehouse-transfer/requests', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`wo/inter-warehouse-transfer/requests/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`wo/inter-warehouse-transfer/requests/${data.id}`, { data })
  }
}

export default TransferService
